import { useState, useEffect } from "react";
import {
	collection,
	onSnapshot,
	query,
	where,
	orderBy,
	getDocs,
} from "firebase/firestore";
import { db } from "../services/firebase";
import { useAuth } from "../contexts/AuthContext";

export function useUserManagement() {
	const { user } = useAuth();
	const [users, setUsers] = useState([]);
	const [deletedUsers, setDeletedUsers] = useState([]);
	const [loading, setLoading] = useState(false);

	// Listen for users in real-time (Trainer only)
	useEffect(() => {
		if (!user || user.role !== "trainer") {
			setUsers([]);
			setDeletedUsers([]);
			return;
		}

		setLoading(true);

		// Listen for all users except current trainer
		const q = query(collection(db, "users"), orderBy("createdAt", "desc"));

		const unsubscribe = onSnapshot(
			q,
			(snapshot) => {
				const allUsers = snapshot.docs.map((doc) => ({
					uid: doc.id,
					...doc.data(),
					createdAt:
						doc.data().createdAt?.toDate?.()?.toISOString() ||
						new Date().toISOString(),
					lastLogin: doc.data().lastLogin?.toDate?.()?.toISOString() || null,
					deletedAt: doc.data().deletedAt?.toDate?.()?.toISOString() || null,
				}));

				// Filter out current user and show only regular users
				const nonTrainerUsers = allUsers.filter(
					(u) => u.uid !== user.uid && u.role !== "trainer",
				);

				// Split into active and soft-deleted lists
				setUsers(nonTrainerUsers.filter((u) => u.isDeleted !== true));
				setDeletedUsers(nonTrainerUsers.filter((u) => u.isDeleted === true));
				setLoading(false);
			},
			(error) => {
				console.error("Error fetching users:", error);
				setLoading(false);
			},
		);

		return unsubscribe;
	}, [user]);

	return { users, deletedUsers, loading };
}
